import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { Colors } from "@root/utils/colors";
import * as styles from "./styles.css";

type Props = {
  workCode: string;
  telNumberContent: {
    telNumber: string;
    isShowTellButton: boolean;
  };
};

export const TelInformation: FC<Props> = ({ workCode, telNumberContent: { telNumber } }) => {
  return (
    <ul className={styles.tellList}>
      <Icon name="tel" color={Colors.OLD_MEDIUM_GREY} fontSize="34px" />
      <li>
        TEL応募：<span className={styles.telNum}>{telNumber}</span>
      </li>
      <li className={styles.workNum}>
        求人番号：<b>{workCode}</b>をお控え下さい
      </li>
    </ul>
  );
};
